import styled from 'styled-components';
import { Form } from '@unform/web';
import { Conteiner as CartaoDeInformacao } from '../../../components/CartaoDeInformacao/styles';

export const Formulario = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  width: 95%;
  margin: auto;

  ${CartaoDeInformacao} {
    width: 97%;
  }
`;

export const CampoConteiner = styled.div`
  display: flex;
  gap: 1rem;

  width: 100%;
`;

export const CamposConteiner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;
`;

export const Divisor = styled.hr`
  width: 100%;
  margin: 10px 0;

  border: none;
  border-top: solid 1px ${(props) => props.theme.BACKGROUND};
`;

export const AcoesConteiner = styled.div`
  display: flex;
  justify-content: flex-end;

  width: 100%;
  margin-right: 10px;
`;
